import React from 'react';
import { string, object, number } from 'prop-types';
import Text from './Text';
import { Row } from '../common';

const Title = ({ text, style, marginTop }) => (
    <Row mT={marginTop} style={style}>
        <Text text={text} size={14} semibold />
    </Row>
);

Title.propTypes = {
    text: string,
    style: object,
    marginTop: number
};

Title.defaultprops = {
    style: {},
    marginTop: 12
};

export default Title;
